<template>
    <div class="title_container">
        <p style="font-family: AliMedium; font-size: 2rem; color: #fff; padding: 1rem 28% 1.2rem;">{{title}}</p>
        <p style="font-family: AliRegular; font-size: 1rem; color: #969696; padding: 0 0 2rem 0;">{{content}}</p>
        <div class="bar_container">
            <div class="title_bar bar_inner"></div>
            <div class="title_bar bar_outer"></div>
        </div>
    </div>
</template>

<script>
export default {
    name:'Title',
    props:{
        title:  String,
        content: String
    }
}
</script>

<style lang="less" scoped>
h1{
    color: #fff;
}
p{
    color: #bfbfbf;
    font-size: 0.8rem;
    letter-spacing: 1px;
}
.title_container{
    text-align: center;
    // background-color: #83f26f;
    // padding-bottom: 1rem;
    .bar_container{
        position: relative;
        // height: 20px;
        // padding-top: 3%;
        margin-bottom: 4rem;
    }
    .title_bar{
        position: absolute;
        top: 50%;
        // transform: translateY(-50%);
        left: 50%;
        transform: translate(-50%,-50%);
    }
    .bar_outer{
        height: 2px;
        width: 3.5rem;
        background-color: #54d1ef;
        // left: 48.5%; /* 根据长线的宽度调整负边距，使两条线居中重合 */
    }
    .bar_inner{
        height: 2px;
        width: 9.75rem;
        background-color: rgb(161, 161, 161);
        // left: 46%; /* 根据长线的宽度调整负边距，使两条线居中重合 */
    }
}
</style>